import axios from "axios";
import {API_ROOT} from "../app/utils";
import {msgBar} from "./msgBarActions";

export function fetchCustomFields () {
    return function (dispatch, getState) {
        axios.get(API_ROOT + '/api/v2/customField', {withCredentials: true}).then((response) => {
            dispatch({
                type: 'FETCH_CUSTOM_FIELDS',
                payload: response.data
            });

	        if(getState().customFieldsReducer.customFieldDetails !== null){
		        response.data.customFields.forEach( item => {
			        if (item.id === getState().customFieldsReducer.customFieldDetails.id) {
				        dispatch(customFieldDetails({id: item.id, type: item.valueType, name: item.label, dropDownOptions: item.dropdownOptions}));
			        }
		        })
	        }
        }).catch(e => {
	        dispatch({
		        type: 'FETCH_CUSTOM_FIELDS',
		        payload: e.response.data
	        });
        })
    }
}

export function fetchCustomFieldsForContactForm () {
    return function (dispatch) {
        axios.get(API_ROOT + '/api/v2/customField/contact', {withCredentials: true}).then((response) => {
            dispatch({
                type: 'FETCH_CUSTOM_FIELDS_FOR_CONTACT_FORM',
                payload: response.data
            });
        }).catch(e => {
        	console.error(e.message)
        })
    }
}

export function editCustomField ( string ) {
	return function (dispatch) {
	    dispatch(updateCustomField(""));
	    dispatch({
			type: 'EDIT_CUSTOM_FIELD',
				payload: string
		})
	}
}

export function updateCustomField ( string ) {
	return {
		type: 'UPDATE_CUSTOM_FIELD',
		payload: string
	}
}

export function isAddingNewCustomField ( boolean ) {
    return {
        type: 'IS_ADDING_CUSTOM_FIELD',
        payload: boolean
    }
}

export function submitCustomField ( string ) {
    return {
        type: 'SUBMIT_CUSTOM_FIELD',
        payload: string
    }
}

export function editCustomFieldOption ( string ) {
	return function (dispatch) {
		dispatch(updateCustomFieldOption(""));
		dispatch({
			type: 'EDIT_CUSTOM_FIELD_OPTION',
			payload: string
		})
	}
}

export function updateCustomFieldOption ( string ) {
	return {
		type: 'UPDATE_CUSTOM_FIELD_OPTION',
		payload: string
	}
}

export function isAddingNewCustomFieldOption ( boolean ) {
	return {
		type: 'IS_ADDING_CUSTOM_FIELD_OPTION',
		payload: boolean
	}
}

export function submitCustomFieldOption ( string ) {
	return {
		type: 'SUBMIT_CUSTOM_FIELD_OPTION',
		payload: string
	}
}

export function postNewCustomField ( string ) {
    return function (dispatch) {
        axios.post(API_ROOT + '/api/v1/customField', {
            "customField": string
        }, {withCredentials: true}).then(() => {
            dispatch(fetchCustomFields());
            dispatch(isAddingNewCustomField(false));
        }).catch(() => {
            console.error('Error on creating custom field');
        }).finally(() => {
            dispatch(submitCustomField(""));
        })
    }
}

export function putCustomField ( id, string, customFieldType ) {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/v2/customField/' + id + '/', {
			"customFieldLabel": string,
			"customFieldValueType": customFieldType
		}, {withCredentials: true}).then((response) => {
			dispatch(fetchCustomFields());
			dispatch(isAddingNewCustomField(false));
			dispatch(updateCustomField(""));
			dispatch(editCustomField(""));
			dispatch(customFieldDetails(null));
			dispatch(msgBar(['success', response.data.message]));
		}).catch(() => {
			console.error('Error on updating custom field');
		}).finally(() => {
			dispatch(submitCustomField(""));
		})
	}
}

export function postCustomFieldOption ( id, optionName ) {
	return function (dispatch) {
		axios.post(API_ROOT + '/api/v2/customField/dropdownOption', {
			"customFieldId": id,
			"customFieldValueType": "DROPDOWN",
			"optionNames": [
				optionName
			]
		}, {withCredentials: true}).then(() => {
			dispatch(fetchCustomFields());
			dispatch(isAddingNewCustomFieldOption(false));
			dispatch(updateCustomField(""));
			dispatch(editCustomField(""));
		}).catch(() => {
			console.error('Error on updating custom field');
		}).finally(() => {
			dispatch(submitCustomFieldOption(""));
		})
	}
}

export function putCustomFieldOption ( id, optionId, newName ) {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/v2/customField/dropdownOption', {
			"customFieldId": id,
			"customFieldValueType": "DROPDOWN",
			"optionUpdates": [
				{
					"existingId": optionId,
					"newName": newName
				}
			]
		}, {withCredentials: true}).then(() => {
			dispatch(fetchCustomFields());
			dispatch(isAddingNewCustomFieldOption(false));
			dispatch(updateCustomField(""));
			dispatch(editCustomField(""));
		}).catch((e) => {
			console.error(e, 'Error on updating custom field');
		}).finally(() => {
			dispatch(submitCustomFieldOption(""));
		})
	}
}

export function deleteCustomFieldOption (customFieldId, optionName) {
	return function (dispatch) {
		axios.delete(API_ROOT + '/api/v2/customField/dropdownOption', {
			withCredentials: true,
			data: {
				"customFieldId": customFieldId,
				"customFieldValueType": "DROPDOWN",
				"optionNames": [
					optionName
				]
			}
		}).then(() => {
			dispatch(fetchCustomFields());
			dispatch(isAddingNewCustomFieldOption(false));
		}).catch(() => {
			console.error('Error on deleting custom field option');
		}).finally(() => {
			dispatch(submitCustomFieldOption(""));
		})
	}
}

export function customFieldDetails ( object ) {
    return {
	    type: 'CUSTOM_FIELD_DETAILS',
	    payload: object
    }
}

export function deleteCustomField ( id ) {
	return function (dispatch) {
		axios.delete(API_ROOT + '/api/v2/customField/' + id + '/', {withCredentials: true}).then(() => {
			dispatch(fetchCustomFields());
			dispatch(isAddingNewCustomField(false));
		}).catch((e) => {
			if(e.response.data){
				dispatch(customFieldDeletionErrorPopup(e.response.data));
			} else {
				console.error('Error on deleting custom field');
			}
		}).finally(() => {
			dispatch(submitCustomField(""));
		})
	}
}

export function customFieldDeletionConfirmationPopup (string) {
	return {
		type: 'CUSTOM_FIELD_DELETION_CONFIRMATION_POPUP',
		payload: string
	}
}

export function customFieldDeletionErrorPopup(error) {
	return {
		type: 'CUSTOM_FIELD_DELETION_ERROR_POPUP',
		payload: error
	}
}
